export const TRANSACTION = 'TRANSACTION';
export const TRANSACTION_ALL = `${TRANSACTION}/ALL`;
export const TRANSACTION_BY_ID = `${TRANSACTION}/BY_ID`;
export const SEND_RECEIPT = `${TRANSACTION}/SEND_RECEIPT`;
export const TRANSACTION_SEARCH = `${TRANSACTION}/SEARCH`;
export const TRANSACTION_REFUND = `${TRANSACTION}/REFUND`;
export const TRANSACTION_CAPTURE = `${TRANSACTION}/CAPTURE`;
export const TRANSACTION_ADJUST = `${TRANSACTION}/ADJUST`;
export const TRANSACTION_EXPORT = `${TRANSACTION}/EXPORT`;
export const TRANSACTION_REFUNDS = `${TRANSACTION}/REFUNDS`;
export const TRANSACTION_DISPUTES = `${TRANSACTION}/DISPUTES`;
export const TRANSACTION_PAYOUTS = `${TRANSACTION}/PAYOUTS`;
export const TRANSACTION_ACTIONS = `${TRANSACTION}/ACTIONS`;
